<div class="popup-bg ">
        <div class="popup">
            <div class="popup-content">
                <h3>Change Password</h3>
                <div class="alert-error" *ngIf="errorMessage">{{errorMessage}}</div>
                <div class="alert-success" *ngIf="successMessage">{{successMessage}}</div>
                <div class="alert-warning" *ngIf="warningMessage">{{warningMessage}}</div>
                <form  [formGroup]="changePassword">
                <div class="input-row input-row-wide">
                    <div class="input-wrap">
                        <span class="input-title">Current Password</span>
                        <input type="password" placeholder="" formControlName = "password">
                    </div>
                </div>
                <div class="input-row input-row-wide">
                    <div class="input-wrap input-wrap-pass">
                        <span class="input-title">New Password</span>
                    <input [type]="showPassword?'text':'password'" placeholder="" formControlName = "newPassword">
                        <span (click)="showPassword=!showPassword" class="eye-icon"></span>
                    </div>
                </div>
                <div class="input-row input-row-wide">
                    <div class="input-wrap">
                        <span class="input-title">Confirm Password</span>
                        <input type="password" placeholder="" formControlName = "confirmPassword">
                    </div>
                </div>
            </form>

                <span *ngIf="submitted && passwordMatched" class="msg-text success-text">Password matched !</span>
                <span *ngIf="submitted && !passwordMatched" class="msg-text incorrect-text">Password not matched !</span>
                <div class="popup-links text-right">
                    <a href="javascript:void(0)" class="btn btn-light" (click)="forPopupClose()">Close</a>
                    <a href="javascript:void(0)" class="btn btn-dark" (click)="UpdateUserProfile()">Update</a>
                </div>
            </div>
        </div>
    </div>